var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticStyle:{"margin":"24px 0"}},[_c('div',{staticClass:"title",attrs:{"slot":"title"},slot:"title"},[_c('div',{staticClass:"vertical"}),_vm._v(" 申请 ")]),_c('div',{staticClass:"main"},[_c('apply-for-pie',{key:"date2",attrs:{"data":_vm.ProportionUserList}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }